import {HttpErrorResponse} from '@angular/common/http';
import {ErrorResponse} from '../models/auth/auth.models';
import {throwError} from 'rxjs';

export function handleHttpError(error: HttpErrorResponse) {
  let errorMessage = 'An unknown error occurred';

  if (error.error instanceof ErrorEvent) {
    // Client-side error
    errorMessage = `Error: ${error.error.message}`;
  } else if (error.error && typeof error.error === 'object') {
    // Server-side error with structured response
    const errorResponse = error.error as ErrorResponse;
    errorMessage = errorResponse.message || `Error ${error.status}: ${error.statusText}`;
  } else {
    // Server-side error without structured response
    errorMessage = `Error ${error.status}: ${error.statusText}`;
  }

  return throwError(() => new Error(errorMessage));
}
